import { FieldType } from '../../types/Field.type';
export const MerchantPortalAccountEmail = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.merchant_portal_account_email.label',
    fallbackLabel: 'Merchant portal email address',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => true,
    type: FieldType.String,
    mfValidation: {
        pathToValidation: 'base/email',
    },
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return false;
}
